import type React from "react"
import { useLocation } from "react-router-dom"
import { Sidebar } from "./sidebar"

// Routes that should not show the sidebar
const ROUTES_WITHOUT_SIDEBAR = [
  "/", // Login page
  "/login", // Alternative login route
  "/register", // Registration page
  "/404", // Not found page
  "/500", // Error page
  "/auth", // Any auth-related pages
]

interface ClientLayoutProps {
  children: React.ReactNode
}

export function ClientLayout({ children }: ClientLayoutProps) {
  const location = useLocation()
  // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)

  // Check if current route should show sidebar
  const shouldShowSidebar = !ROUTES_WITHOUT_SIDEBAR.some((route) => location.pathname === route || location.pathname.startsWith("/auth/"))

  const handleSidebarCollapsedChange = (_collapsed: boolean) => {
    // setIsSidebarCollapsed(collapsed)
    // Future: use collapsed state for responsive layout
  }


  if (shouldShowSidebar) {
    // Layout with sidebar for admin pages
    return (
      <div className="h-screen bg-background flex overflow-hidden">
        <div className="flex-shrink-0">
          <Sidebar onCollapsedChange={handleSidebarCollapsedChange} />
        </div>
        <main className="flex-1 overflow-auto">
          <div className="p-6">{children}</div>
        </main>
      </div>
    )
  }

  // Full-width layout for auth and error pages
  return <>{children}</>
}
